<script>
  import {
    Field,
    FieldActions,
    FieldError,
    FieldHeader,
    FieldLabel,
    FieldValue
  } from '@client/components/fields/standalone/base';
  import { Input } from '@client/components/input';

  export let id = null;
  export let label = null;
  export let value = null;
  export let formatValue = (val) => val || '-';

  export let validation = undefined;
  export let validationError = undefined;

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let ref = null;
  export let readonly = false;
  export let editing = false;
  export let blur = false;
  export let placeholder = '';
  export let allowCopy = false;

  export let showActions = true;

  export let onChange = () => {};
  export let onUpdate = () => {};
  export let formatInput = (val) => val;

  let newValue = value;
  let disableSubmit = true;
  let error = false;

  const onEdit = () => {
    editing = true;
    setTimeout(() => ref && ref.focus(), 100);
  };

  const onCancel = () => {
    editing = false;
    error = false;
    newValue = value;
  };

  const onKeyUp = () => {
    error = false;

    newValue = formatInput(newValue);

    if (onChange) {
      onChange(id, label, newValue);
    }
  };

  const onSave = () => {
    if (newValue.length && validation && !validation(newValue)) {
      error = true;

      setTimeout(() => ref && ref.focus(), 100);

      return false;
    }

    value = formatInput(newValue);
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, value);
    }
  };

  $: disableSubmit = value === newValue;
  $: classes = error ? 'raw error' : 'raw';
  $: blurred = blur && !editing;
</script>

<Field bind:error bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} bind:error />
    <FieldActions
      bind:readonly
      bind:editing
      bind:disableSubmit
      {onSave}
      {onEdit}
      {onCancel}
      {showActions}
      {allowCopy}
      bind:copyValue={newValue}
    />
  </FieldHeader>
  <FieldValue bind:error bind:blur={blurred} {showActions}>
    {#if editing}
      <Input
        {id}
        data-testid="field-input"
        type="text"
        class={classes}
        {placeholder}
        bind:ref
        bind:value={newValue}
        on:keyup={onKeyUp}
      />
    {:else}
      {@html formatValue(newValue)}
    {/if}
  </FieldValue>
  <FieldError bind:error {validationError} />
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./text.scss"></style>
